import { inject, Pipe, PipeTransform } from '@angular/core';
import { PermissionService } from '@feature-services/permission.service';

@Pipe({
  name: 'calioPermissionChecker',
  standalone: true
})
export class CalioPermissionCheckerPipe implements PipeTransform {

  private permissionService = inject(PermissionService);

  /**
   * Transforms the input value by checking if the user has the required permissions.
   *
   * @param value - A string or an array of strings representing the required permissions.
   * @param filterModeAND - A boolean indicating whether all permissions are required (AND mode) or any one of them is sufficient (OR mode). Defaults to false (OR mode).
   * @returns A boolean indicating whether the user has the required permissions.
   */
  transform(value: string | string[], filterModeAND = false): boolean {
    return this.permissionService.hasPermission(value, filterModeAND);
  }
}
